import { Progress } from "antd";
import { CascadeFailed } from "components/UI/Cascade/CascadeFailed.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useEffect, useState } from "react";

const TOTAL_SECONDS = 120;

export const CascadeProcessing = () => {
    const { t } = usePaldockTranslation("ui.cascade");
    const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
            return () => clearInterval(timer);
        }
    }, [timeLeft]);

    const formatTime = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}`;
    };

    const progressPercent = (timeLeft / TOTAL_SECONDS) * 100;

    if (timeLeft === 0) {
        return <CascadeFailed />;
    }

    return (
        <div className="flex flex-col items-center gap-4 px-4 font-['Poppins',sans-serif]">
            <Progress
                type="circle"
                size={240}
                percent={progressPercent}
                format={() => (
                    <span className="text-7xl font-extrabold leading-none text-[#222]">{formatTime(timeLeft)}</span>
                )}
                strokeColor={{ "0%": "#6fdc97", "100%": "#34b86a" }}
                strokeWidth={6}
            />
            <h1 className="m-0 text-center text-base font-medium text-[#222]">
                {t("content.processing_request_moment")}
            </h1>
        </div>
    );
};
